import { ItemFilter } from "./item-filter";
import { StringFilter } from "./string-filter";

export class DispatchFormFilter {
    public name?: StringFilter;
    public parent?: ItemFilter;
}
